// Import jquery-ujs (if you need its Rails-specific helpers)
import 'jquery-ujs'

// Import jQuery UI widgets and localization files for datepicker
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/i18n/datepicker-fr'
import 'jquery-ui/ui/i18n/datepicker-de'

// Import Bootstrap and its slider plugin
import 'bootstrap'
import 'bootstrap-slider'

// Import disable-scroll and assign it to the global scope if needed
import disableScroll from 'disable-scroll'
window.disableScroll = disableScroll

import "@fortawesome/fontawesome-free/js/all"
import "summernote"
import "chosen-js"

import './analytics'
import './navigation'
import './delivery_terms'
// import './commontator/application'
import './custom'
import './shadow_alternatives'
import './front_summernote'

import '../stylesheets/application.css'
